var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'select')?_c('v-select',_vm._b({attrs:{"value":_vm.value,"items":_vm.analysis_titles,"item-value":"id","item-text":"full_name","placeholder":_vm.name,"readonly":""}},'v-select',_vm.$attrs,false)):_c('span',[_vm._v(_vm._s(_vm.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }